import { render } from "./BaseDropMobile.vue?vue&type=template&id=81d7d4a8"
import script from "./BaseDropMobile.vue?vue&type=script&lang=js"
export * from "./BaseDropMobile.vue?vue&type=script&lang=js"
script.render = render

export default script